export default __webpack_public_path__ + "static/media/xpensityV1-lg-2.400c3b93.webp";